import React, { useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { DELETE_DUPLICATED_BOX } from '../../mutation/mutation';

const DeleteDuplicatedBox = withApollo(({ client }) => {
  const [pairing, setPairing] = useState('');
  const deleteDuplicatedBox = () => {
    client.mutate({
      mutation: DELETE_DUPLICATED_BOX,
      variables: {
        pairing,
      },
    }).then(() => {
      alert('Success ✅');
    }).catch((err) => {
      alert('Error :(' + err);
    });
  };

  return (
    <div>
      <hr />
      <Form>
        <FormGroup>
          <Label>Pairing code</Label>
          <Row>
            <Col>
              <Input
                type="text"
                value={pairing}
                onChange={({ target: { value } }) => setPairing(value)}
              />
            </Col>
            <Col>
              <Button
                color="danger"
                onClick={() => deleteDuplicatedBox()}
              >
                Delete duplicated boxes
              </Button>
            </Col>
          </Row>
        </FormGroup>
      </Form>
    </div>
  );
});

export default DeleteDuplicatedBox;



// WEBPACK FOOTER //
// ./src/components/admin/delete-duplicated-box.js